import React, {FC}  from 'react';

// import MUI.
import {Avatar, Button, Grid, Typography, Link, Box, Paper, TextField, MenuItem, IconButton} from '@mui/material';
import {Menu as MenuIcon, AccountCircle as AccountCircleIcon, 
  Home as HomeIcon, ManageAccounts as ManageAccountsIcon, Logout as LogoutIcon } from '@mui/icons-material';
// import library.


// import user Component

// import user Library.


const BankAgency: FC = () => {
    return (
      <>
        <Grid container component="main" sx={{ height: '100vh' }}>
          <Grid item xs={12}  component={Paper} elevation={6} square>
              Bank Agency
          </Grid>         
        </Grid>
      </>
    );
  }
  
  export default BankAgency;